import { Icon as ChakraIcon, IconProps } from '@chakra-ui/react';

export const Icon: React.FC<IconProps> = ({ path, ...rest }) => (
	<ChakraIcon {...rest}>
		<path d={path} />
	</ChakraIcon>
);
